import axios from 'axios'
import baseUrl from '../config.json'

export const getuser = ()=>{
    return axios.get(baseUrl.apiEndPoint+"/api/getuser")
}
const api={
    getuser
}
export default api